// extracted by mini-css-extract-plugin
export default {"shared":"'../../../shared.module.css'","md":"768px","lg":"992px","breakLine":"BreakLine_breakLine__8myU2"};